module.exports = __webpack_public_path__ + "img/nicole-600x600.5fa9ee86.png";